"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isColorOption = void 0;
var _types = require("../types");
const isColorOption = (props)=>props.type === _types.FilterOptionType.Color;
exports.isColorOption = isColorOption;
